// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// RxJS
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
// Translate
import { TranslateService } from '@ngx-translate/core';
import { ConfirmPasswordValidator } from '../register/confirm-password.validator';
import { Auth } from 'aws-amplify';
import { MixpanelService } from '../../../../../app/services/mixpanel.service';
// Auth
// import { AuthNoticeService, AuthService } from '../../../../core/auth';

@Component({
	selector: 'kt-forgot-password',
	templateUrl: './forgot-password.component.html',
	encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
	// Public params
	forgotPasswordForm: FormGroup;
	codeForm: FormGroup;
	loading = false;
	codeLoading = false;
	errors: any = [];

	alertType = null;
	alertMessage = null;

	codeSentMsg;

	showCodeForm = false;

	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	constructor(
		private translate: TranslateService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private mixPanelService: MixpanelService,

	) {
		this.unsubscribe = new Subject();
	}

	ngOnInit() {
		this.initForms();
		this.mixPanelService.track('Forgot Password Page');
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initForms() {
		this.forgotPasswordForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320)
			])
			]
		});

		this.codeForm = this.fb.group({
			code: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(320)
			])
			],
			password: ['', Validators.compose([
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(100)
			])
			],
			confirmPassword: ['', Validators.compose([
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(100)
			])
			],
		},
		{
			validator: ConfirmPasswordValidator.MatchPassword
		});
	}

	forgotSubmit() {
		const controls = this.forgotPasswordForm.controls;
		/** check form */
		console.log('fs');
		this.alertType = null;
		this.alertMessage = null;

		if (this.forgotPasswordForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);


			return;
		}

		this.loading = true;

		const email = controls.email.value;

		Auth.forgotPassword(email)
		.then(data => {
			if (data) {
				this.alertMessage =  'Code has been sent to ' + data.CodeDeliveryDetails.Destination;
				this.alertType = 'success';
				this.showCodeForm = true;
				this.loading = false;
			} else {
				this.alertMessage =  'An Error Occurred.';
				this.alertType = 'danger';
				this.loading = false;
			}
			this.cdr.detectChanges();
		})
		.catch(err => {
			console.log(err);
			this.alertMessage =  err.message || 'An Error Occurred.';
			this.alertType = 'danger';
			this.loading = false;
			this.cdr.detectChanges();
		});

	}

	codeSubmit() {
		this.alertType = null;
		this.alertMessage = null;

		this.codeLoading = true;
		this.cdr.detectChanges();

		Auth.forgotPasswordSubmit( this.forgotPasswordForm.get('email').value, this.codeForm.get('code').value,
		this.codeForm.get('password').value)
		.then(data => {
			this.router.navigate(['login']);
		})
		.catch(err => {
			this.alertMessage =  err.message || 'An Error Occurred.';
			this.alertType = 'danger';
			this.codeLoading = false;
			this.cdr.detectChanges();
		});
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}
}
